<div class='or-job-tasks-tile-content'>
  <table class='job-tasks-table'>
    <tr>
      <th> Started</th>
      <th> Ended</th>
      @if (dataSource().expectedCount) {
        <th> Actual count</th>
      }
      @if (dataSource().expectedCount) {
        <th> Expected count</th>
      }
    </tr>
    <tr>
      <td> {{dataSource().startedDateTime ? dateInLocale(dataSource().startedDateTime) : 'N/A'}} </td>
      <td> {{dataSource().endedDateTime ? dateInLocale(dataSource().endedDateTime) : 'N/A'}} </td>
      @if (dataSource().expectedCount) {
        <td> {{dataSource().count ?? 'N/A'}} </td>
      }
      @if (dataSource().expectedCount) {
        <td> {{dataSource().expectedCount?? 'N/A'}} </td>
      }
    </tr>
  </table>
</div>
